export default "__VITE_ASSET__945f774a__"